<template>
  <div class="side-bar-promo-desktop">
    <div class="side-bar-promo-desktop__item _coupon">
      <app-coupon
        :is-fetch-basket="true"
        :button-text="buttonText"
        :show-icon="showIcon"
        @couponChanged="handlerChangedPromoCode"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from '@vue/composition-api';
import { useBreakpoints } from '@vueuse/core';

import { BREAKPOINTS } from '@/utils/constants/globalConst';
import { checkMobile } from '@/utils/deviceCheck';

import AppCoupon from '@/components/AppCoupon';
import MnogoRuCardAsCoupon from '@/components/MnogoRuCardAsCoupon';

export default defineComponent({
  name: 'SideBarPromo',
  components: {
    AppCoupon,
    MnogoRuCardAsCoupon,
  },
  setup(props, { emit }) {
    const breakpoints = useBreakpoints(BREAKPOINTS);
    const isMobile = checkMobile();

    const isTablet = breakpoints.smaller('tablet');

    const showMnogoRuCard = ref(false);

    const buttonText = computed(() => (!isMobile && isTablet.value ? 'Ок' : 'Применить'));

    const showIcon = computed(() => {
      if (isMobile) {
        return true;
      }
      return !isTablet.value;
    });

    const handlerChangedPromoCode = () => emit('changePromoCode');

    const handlerChangeMnogoruCard = () => emit('changeMnogoRuCard');

    const handlerShowMnogoRuCard = (show = true) => {
      showMnogoRuCard.value = show;
      if (show) {
        emit('showMnogoRuCard');
      }
    };

    const handlerChangeShowMnogoRuCard = (show) => {
      if (show) {
        handlerShowMnogoRuCard(show);
      }
    };

    return {
      isTablet,
      showIcon,
      buttonText,
      showMnogoRuCard,
      handlerChangedPromoCode,
      handlerChangeMnogoruCard,
      handlerShowMnogoRuCard,
      handlerChangeShowMnogoRuCard,
    };
  },
});
</script>

<style lang="less">
.side-bar-promo-desktop {
  &__item {
    &._coupon {
      margin-bottom: @size-x6;
    }
  }

  &__visible-button {
    .button-reset();
    .p();

    color: @link;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
  }
}
</style>
